module.exports = __webpack_public_path__ + "media/misc/fade-base-ce3d41b6.png";